import { ExpertNotificationTypeEnum } from 'types/api.types.generated';
import { NotificationTypeEnum } from 'types/enums/notification-type.enum';

const notificationsHiddenWhenViewed = [
  NotificationTypeEnum.CvExtractionFailed,
  NotificationTypeEnum.AirConversationNotFinished,
  NotificationTypeEnum.JobOrderApplicationPreferencesStepNotFinished,
  NotificationTypeEnum.IncompleteProfile,
];

export interface NotificationDto {
  id: string;
  type: ExpertNotificationTypeEnum;
  metadata?: string | null;
  createdAt: Date;
  viewedAt?: Date | null;
  relatesTo: {
    jobOrderId?: string | null;
    jobOrderApplicationId?: string | null;
  };
}

export interface NotificationMetadata {
  jobOrderId?: string;
  jobOrderName?: string;
  selectedMeetingDate?: string;
  matchScore?: number;
}

export const mapDtoToNotification = (dto: NotificationDto): Notification | null => {
  const parsedMetadata = dto.metadata ? (JSON.parse(dto.metadata) as NotificationMetadata) : null;

  if (
    !!dto.viewedAt &&
    notificationsHiddenWhenViewed.includes(dto.type as unknown as NotificationTypeEnum)
  ) {
    return null;
  }

  return {
    id: dto.id,
    type: dto.type as unknown as NotificationTypeEnum,
    jobOrderId: dto.relatesTo.jobOrderId || parsedMetadata?.jobOrderId || null,
    metadata: parsedMetadata,
    createdAt: dto.createdAt,
    viewedAt: dto.viewedAt ?? null,
  };
};

export interface Notification {
  id: string;
  type: NotificationTypeEnum;
  jobOrderId: string | null;
  metadata: NotificationMetadata | null;
  createdAt: Date;
  viewedAt: Date | null;
}
